import { create } from "zustand";

type FeedbackStore = {
	isOpen: boolean;
	open: () => void;
	close: () => void;
};

export const useFeedbackStore = create<FeedbackStore>((set) => ({
	isOpen: false,
	open: () => set({ isOpen: true }),
	close: () => set({ isOpen: false }),
}));
